import { withWalletConnectCheck } from 'modules/wallet/hocs/withWalletConnectCheck'
import type { RouteMeta, RouteObjectWithMeta } from '../types'

type Args = RouteMeta & {
  component: React.ComponentType
  checkConnect?: boolean
}

export function createRoute({
  component,
  checkConnect,
  ...routeMeta
}: Args): RouteObjectWithMeta {
  const Component = checkConnect
    ? withWalletConnectCheck(component, {
        isCentered:
          routeMeta.layoutType !== 'narrow' &&
          routeMeta.layoutType !== 'narrow-extended',
      })
    : component
  return {
    element: <Component />,
    routeMeta,
  }
}
